import { type CSSProperties, useMemo } from 'react';

type RichTextEditorStyle = {
  '--rte-editor-max-height'?: string;
  '--rte-editor-min-height'?: string;
} & CSSProperties;

type UseCreateRichTextEditorStyleProperties = {
  maxHeight?: number;
  minHeight?: number;
};

export const useCreateRichTextEditorStyle = ({ maxHeight, minHeight }: UseCreateRichTextEditorStyleProperties) =>
  useMemo<RichTextEditorStyle>(() => {
    const editorStyle: RichTextEditorStyle = {};

    if (minHeight !== undefined) {
      editorStyle['--rte-editor-min-height'] = `${minHeight}px`;
    }

    if (maxHeight !== undefined) {
      editorStyle['--rte-editor-max-height'] = `${maxHeight}px`;
    }

    return editorStyle;
  }, [maxHeight, minHeight]);
